/* eslint-disable unicorn/prevent-abbreviations */
export default {
  auto: '*',
}
